<!-- 
 * @description: 中药诊断表单项
 * @author: 翠山 
 * @date: 2021-02-24 16:51:38 
 * @后台人员: 冬枣 
!-->
<template>
    <div>
        <van-cell class="no-border diagnose" :required="inquiryType === 1">
            <div class="box">
              <div class="box-top">
                <p class="box-title">诊断 <span>（最多可选5项）</span></p>
              </div>
              <div class="tips">
                <span
                  v-for="(tip,index) in selectedList"
                  :key="index + Math.random()"
                  :class="['tip',{ active: tip.active }]"
                  @click="handleClickDiagnose(tip)"
                  >{{ tip.diagnosisName }}</span
                >
                <span class="tip" @click="$emit('showDiagnose')">
                  <van-icon name="plus"/> 添加
                </span>
              </div>
            </div>  
          </van-cell>
    </div>
</template>

<script>
    export default {
        props:['inquiryType','selectedList',],
        data(){
            return {

            }
        },
        methods:{
            handleClickDiagnose(tip){
                this.$emit('handleClickDiagnose',tip)
            }
        }
    }
</script>

<style scoped lang="scss">
.van-cell {
  &.no-border {
    font-family: inherit;
    &:after {
      border: none;
    }
  }
}
.diagnose.van-cell--required::before{
  top:20px;
}
.box {
  .box-top {
    padding-top: 15px;
    display: flex;
    justify-content: space-between;
    .box-title {
      margin: 0;
      color: rgba(51, 51, 51, 1);
      line-height: 28px;
      span {
        padding-left: 5px;
        font-size: 14px;
        color: #999;
      }
    }
    img {
      width: 18px;
      height: 18px;
    }
  }
  .tips-title {
    margin: 18px 0 0 0;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(51, 51, 51, 1);
    line-height: 22px;
  }
  .remark-area {
    // height: 100px;
    background: rgba(248, 248, 248, 1);
    border-radius: 8px;
    margin: 20px 0 10px;
  }
  .tips {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 10px;
    .tip {
      padding: 5px 15px;
      background: rgba(248, 248, 248, 1);
      border-radius: 16px;
      font-size: 15px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333;
      margin-right: 10px;
      margin-top: 10px;
      border: 1px solid rgba(248, 248, 248, 1);
      max-width: 285px;
      // white-space: pre-line;
      word-break: break-all;
      .van-icon-plus:before{
        vertical-align: middle;
        color:#C7C7CC;
      }
    }
    .active {
      background: rgba(243, 250, 255, 1);
      border-radius: 18px;
      border: 1px solid #01B956;
      font-weight: 500;
      color: #01B956!important;
    }
  }
}
</style>